import '@babel/polyfill'; // eslint-disable-line import/no-unassigned-import

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import Routes from './routes';
import { Provider } from 'react-redux';
import createStore from './redux/store';
import { ApolloProvider } from '@apollo/client';
import { MortarProvider, Modal } from '@policygenius/mortar';

import apolloClient from './util/apollo/client';
import frontlineBuildInfo from './util/frontlineBuildInfo';
import { setSentryFrontlineContext } from './util/sentry';
import { initPgExperiments } from './util/optimizelyHelpers';
import AuthProvider from './contexts/Auth';
import ErrorBoundary from './components/ErrorBoundary';

// eslint-disable-next-line import/no-unassigned-import
import '@policygenius/mortar/dist/theme/fonts.css';

const store = createStore();

frontlineBuildInfo();
setSentryFrontlineContext();

Modal.setAppElement('#root');

/* eslint-disable no-undef */
if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
  initPgExperiments();
}

ReactDOM.render(
  <Provider store={store}>
    <ApolloProvider client={apolloClient}>
      <MortarProvider>
        <AuthProvider>
          <ErrorBoundary>
            <Routes />
          </ErrorBoundary>
        </AuthProvider>
      </MortarProvider>
    </ApolloProvider>
  </Provider>,
  document.getElementById('root')
);
